//
//
//
//
//
//

    import vFooter from '../common/footer.vue'
    import {memberShareCount,memberShareCountByOpenid} from '@/base/js/api'   
    export default {
        name: 'app',
        data() {
            return {
                data:'',
                isfxImg:false
            }
        },
        created(){
           //2018年12月4日15:02:25 skh修改 改成获取openid
//         let countParam  = {
//              memberShareId : this.$route.query.memberShareId,
//              uvId :this._wxTool.getUVId()
//          }
//          memberShareCount(countParam).then(res=>{
//              if(res.code == 0){
//                  console.log(res);
//                  location.href = res.data.contentUrl
//                      
//              }else{
//              	
//              }
//          })
						this._wxTool.auth();//判断是否授权
            let countParam  = {
                memberShareId : this.$route.query.memberShareId,
                accessToken:this._wxTool.getAccessToken()
            }
            memberShareCountByOpenid(countParam).then(res=>{
                if(res.code == 0){
                    console.log(res);
                    location.href = res.data.contentUrl
                        
                }else{
                	
                }
            })
        },
        components: {
           vFooter 
        },
        methods: {
         
        }
    }



// WEBPACK FOOTER //
// ./src/pages/loading/loading.vue